import { SiteSiteTypeEnum, type CloudAccessConnection, type DiscoveryJobschema, type Site } from '@app/types/sdk';

export type AzureRunReadiness = {
  isAzure: boolean;
  enabled: boolean;
  message?: string;
};

const azurePendingMessage = 'Azure is still applying access. Check access in Cloud Access before starting Discovery.';
const siteResolutionMessage = 'Checking the selected Site before starting Discovery…';
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const normalizeSubscriptionID = (value?: string | null): string => {
  const normalized = value?.trim().toLowerCase() ?? '';
  return uuidPattern.test(normalized) ? normalized : '';
};

export const resolveAzureRunReadiness = (
  job: DiscoveryJobschema | null,
  sites: Site[],
  connections: CloudAccessConnection[]
): AzureRunReadiness => {
  if (!job?.siteId) {
    return { isAzure: false, enabled: true };
  }
  const site = sites.find((candidate) => candidate.id === job.siteId);
  if (!site) {
    return { isAzure: true, enabled: false, message: siteResolutionMessage };
  }
  if (site.siteType !== SiteSiteTypeEnum.AzureCloud) {
    return { isAzure: false, enabled: true };
  }

  const subscriptionID = normalizeSubscriptionID(site.azureSubscriptionId);
  if (!subscriptionID) {
    return { isAzure: true, enabled: false, message: azurePendingMessage };
  }

  const connection = connections.find(
    (candidate) =>
      candidate.provider?.trim().toLowerCase() === 'azure' &&
      candidate.type?.trim() === 'cloudDiscovery' &&
      normalizeSubscriptionID(candidate.accountId) === subscriptionID
  );
  if (connection?.status?.trim().toLowerCase() === 'enabled') {
    return { isAzure: true, enabled: true };
  }
  return { isAzure: true, enabled: false, message: azurePendingMessage };
};
